/* eslint-disable */
import React, { Component } from "react";
import { validated } from "react-custom-validation";

const isEmpty = (value) => (value === "" ? "This field is required." : null);

function validationForgot(props) {
  const { otp } = props.fields;
  return {
    fields: ["otp"],
    validations: {
      otp: [[isEmpty, otp]],
    },
  };
}

class Otpverify extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgOtp;
    if ($validation.otp.error.reason !== undefined) {
      errMsgOtp = $validation.otp.show && (
        <span className="error">{$validation.otp.error.reason}</span>
      );
    } else if (
      fields.otp_error !== "" &&
      typeof fields.otp_error !== undefined &&
      typeof fields.otp_error !== "undefined"
    ) {
      errMsgOtp = $validation.otp.show && (
        <span className="error">{fields.otp_error}</span>
      );
    }
    return (
      <div className="popup-body">
        <div className="form-group">
          <div className="focus-out">
            <label>OTP</label>
            <input
              type="text"
              className="form-control input-focus"
              value={fields.otp}
              {...$field("otp", (e) => onChange("otp", e.target.value))}
            />
            {errMsgOtp}
            <div id="form-msg"></div>
          </div>
        </div>
        <div className="form-group">
          <div className="login_pop_sub otp_verify">
            <button
              type="button"
              className="btn btn_black btn_minwid forgotpassword-cls"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Verify
            </button>
          </div>
        </div>

        <div className="form-group">
          <div className="controls single-link">
            <a href="#guest-popup" className="open-popup-link">
              Back to login
            </a>
          </div>
        </div>
      </div>
    );
  }
}

Otpverify = validated(validationForgot)(Otpverify);

export default Otpverify;
